spec_version: '1.1'
id: 2
slug: 02-fondo-de-emergencia
titulo: Fondo de emergencia
duracion_min: 75
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-02.1
  texto: Calcular el tamaño objetivo del fondo según tu situación
  bloom: ''
- id: OA-02.2
  texto: Comparar productos donde alojar el fondo según liquidez y rentabilidad
  bloom: ''
- id: OA-02.3
  texto: Configurar una aportación automática mensual
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '2.1'
  titulo: Qué es y para qué sirve un fondo de emergencia
  duracion_min: 10
- id: '2.2'
  titulo: Cuántos meses de gastos cubrir
  duracion_min: 15
- id: '2.3'
  titulo: 'Dónde guardarlo: liquidez vs rentabilidad'
  duracion_min: 15
- id: '2.4'
  titulo: Cuentas remuneradas y depósitos a la vista
  duracion_min: 15
- id: '2.5'
  titulo: Cómo automatizar la aportación mensual
  duracion_min: 10
- id: '2.6'
  titulo: Errores típicos al gestionar el fondo
  duracion_min: 10
